import { useEffect, useState } from "react";

import "common/css/master.css";

const AbsentTeachersTbl = (props) => {
    const { lstTchAbsent, tchId, setTchId, absentDt, setAbsentDt } = props;

    const [lstTchAbsentFiltered, setLstTchAbsentFiltered] = useState([]);
    const [teacherFiltered, setTeacherFiltered] = useState("");

    useEffect(() => {
        // // console.log("useEffect in AbsentTeachersTbl component called, lstTchAbsent", props.lstTchAbsent);
        setTeacherFiltered("");
        setLstTchAbsentFiltered(lstTchAbsent);
    }, [lstTchAbsent]);

    const handleFilterTeacher = (fTeacher) => {
        setTeacherFiltered(fTeacher);
        filterTeacherTable(fTeacher);
    }

    const filterTeacherTable = (fTeacher) => {
        const filtered = lstTchAbsent.filter(item => item.tch.toLowerCase().includes(fTeacher.toLowerCase()));
        setLstTchAbsentFiltered(filtered);
    }

    const colgrp = <colgroup>
        <col width="40"></col>
        <col width="40"></col>
        <col width="75"></col>
        <col width="40"></col>
        <col width="40"></col>
        <col width="40"></col>
    </colgroup>


    return (
        <div className="col-sm-12 padding-remove">
            <div className="col-sm-12 padding-remove">
                <table className="tableLayout1" >
                    {colgrp}
                    <thead>
                        <tr>
                            <th>From</th>
                            <th>To</th>
                            <th >
                                <input
                                    type="text" className="form-control inp-search"
                                    value={teacherFiltered}
                                    onChange={(e) => handleFilterTeacher(e.target.value)}
                                    name="teacher name"
                                    placeholder="Teacher" />
                            </th>
                            <th>Start</th>
                            <th>End</th>
                            <th>Applied On</th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "60vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="diaryMonthlyTeacherAllocationTable" >
                            {lstTchAbsentFiltered && lstTchAbsentFiltered.length > 0 ? (
                                lstTchAbsentFiltered.map((item, i) => (
                                    <tr key={item.tchId + "-" + item.fromDt + "" + item.endDt + "-" + i}
                                        onClick={() => { setTchId(item.tchId); setAbsentDt(item.absentDt); }}
                                        className={item.tchId === tchId && item.absentDt === absentDt ? "selected" : ''}>
                                        <td className="text-left">{item.fromDt}</td>
                                        <td className="text-left">{item.endDt}</td>
                                        <td className="text-center">{item.tch}</td>
                                        <td className="text-center" >{item.startTm}</td>
                                        <td className="text-center" >{item.endTm}</td>
                                        <td className="text-center" >{item.appliedOn}</td>
                                    </tr>
                                ))
                            ) : null }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );

}

export default AbsentTeachersTbl;